import classNames from 'classnames'
import React, { Component } from 'react'
import R from '../ramda'
import U from '../Utils'
import './MenuFilter.css'
import MenuFilterPopup from './MenuFilterPopup'

class MenuFilter extends Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,

      // {loading: true}, {error: 'msg'} oppure i dati ricevuti
      data: null,
    }
  }

  loadData() {
    U.loadJsonData(this.props.dictUrl, (data) => this.setState({ data }))
  }

  handleOpen() {
    this.setState((prevState) => {
      let { data } = prevState
      let state = { open: true }
      if (data == null || data.error) {
        state.data = { loading: true }
        this.loadData()
      }
      return state
    })
  }

  handleClose() {
    this.setState({ open: false })
  }

  render() {
    let { label, values, onChange, isSingleSelect } = this.props
    let { open, data } = this.state
    return (
      <div className="MenuFilter">
        <button
          className={classNames({
            btn: true,
            default: R.isEmpty(values),
            active: !R.isEmpty(values),
            single: isSingleSelect,
          })}
          onClick={() => this.handleOpen()}
        >
          {label}
        </button>
        {open && data && (
          <MenuFilterPopup
            loading={data.loading}
            error={data.error}
            items={data.items}
            values={values}
            onClose={() => this.handleClose()}
            onChange={onChange}
            isSingleSelect={isSingleSelect}
          />
        )}
      </div>
    )
  }
}

export default MenuFilter



// WEBPACK FOOTER //
// ./src/filters/MenuFilter.js